/**
 * Created by mykurisu on 2017/8/21.
 */
import React from 'react'
import '../../css/wkCommon.css'

class WKBottomBtn extends React.Component {
    /*const btnContent = {
     text: '添加管理员',
     method: () => {
     console.log(1)
     }
     }*/
    render() {
        const {btnContent} = this.props;

        return (
            <div className={`wk-bottombtn`}>
                <div className="wk-bottom-btn"
                     style={{
                         backgroundColor: btnContent.bcolor ? btnContent.bcolor : '#1AAD19',
                         border: btnContent.border ? btnContent.border : 'none',
                         color: btnContent.color ? btnContent.color : 'white'
                     }}
                     onClick={btnContent.method}>
                    {btnContent.text}
                </div>
            </div>
        )
    }
}

export default WKBottomBtn


// WEBPACK FOOTER //
// ./src/components/wk/WKBottomBtn.js